export function amIPrerender() {
    return navigator.userAgent.includes('https://github.com/prerender/prerender');
}
